import * as _ from 'lodash';

export class DataService {

  // private BasePath : string ="http://localhost:5160/api/";
   private BasePath: string = "https://winzticketapi.azure-api.net/api/";
  private header: any =
    {
      'Content-Type': 'application/json',
      'ApiKey': '*67&<hph3+6sB[w948}#=yx',
      'Ocp-Apim-Subscription-Key': 'b25586d5e0ba40ac9248a9b2e84b3028',
      'Ocp-Apim-Trace': 'True'
    };

  Post(controller: string, apiMethod: string, parm: object): Promise<Response> {
    var route: string = this.BasePath + `${controller}/${apiMethod}`;
    return fetch(route, {
      method: 'POST',
      body: JSON.stringify(parm),
      headers: this.header
    })
  }

  Get(controller: string, apiMethod: string, parm: any = null): Promise<Response> {
    var queryString = (parm == null) ? "" : Object.keys(parm).map(function (key) {
      return key + '=' + parm[key]
    }).join('&');
    var route: string = this.BasePath + `${controller}/${apiMethod}`;
    route = (queryString == "") ? route : route + "?" + queryString;
    return fetch(route, {
      method: 'GET',
      headers: this.header
    })
  }

}